import React from "react";
import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { checkTokenUserAdmin } from "../../utils/authUtils";

const PrivateRoute = ({
  component: Component,
  auth: { loading },
  redirectTo = "/admin",
  ...rest
}) => {
  const { isAuthenticated, isAuthenticatedAdmin } = checkTokenUserAdmin();

  const renderRoute = (props) => {
    // console.log(loading)
    // if (loading) {
    //   return <div>Loading...</div>; // or a spinner
    // }

    if (rest.path.includes("/admin")) {
      return isAuthenticatedAdmin ? (
        <Component {...props} />
      ) : (
        <Redirect to={redirectTo} />
      );
    }

    return isAuthenticated ? (
      <Component {...props} />
    ) : (
      <Redirect to={redirectTo} />
    );
  };

  return <Route {...rest} render={renderRoute} />;
};

PrivateRoute.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStatetoProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStatetoProps)(PrivateRoute);
